import { render, staticRenderFns } from "./BotaoModalAgenteSistema.vue?vue&type=template&id=502d9131&scoped=true&"
import script from "./BotaoModalAgenteSistema.vue?vue&type=script&lang=js&"
export * from "./BotaoModalAgenteSistema.vue?vue&type=script&lang=js&"
import style0 from "./BotaoModalAgenteSistema.vue?vue&type=style&index=0&id=502d9131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d9131",
  null
  
)

export default component.exports